<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <field
            v-model="value.TypeName"
            name="type-name"
        />

        <field
            v-model="value.CaravanDescription"
            name="caravan-description"
        />

        <field
            v-model="value.RegistrationNumber"
            name="registration-number"
        />

        <field
            v-model="value.VinNumber"
            name="vin-number"
        />

        <field
            v-model="value.Year"
            name="model-year"
        />

        <field
            v-model="value.TotalWeight"
            name="total-weight"
        />
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'Caravan',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
